import { TColors } from '@com/core/common/types/styles/colors_v2';
import { breakpoints } from '@com/core/common/styles/baseStyles';
import { css } from 'styled-components';

// Use this if using semi-transparent colors/backgrounds
// const getRGBA = (hex: string, alpha = 1): string =>
//     `rgba(${parseInt(hex.substring(1, 3), 16)},${parseInt(hex.substring(3, 5), 16)},${parseInt(
//         hex.substring(5, 7),
//         16,
//     )},${alpha})`;

type TNoonColors = TColors & {
    bgSupport: string;
    bgSupportAlt: string;
    bgSupportLight: string;
    bgTrigger: string;

    body: string;
    bodyDark: string;
    bodyAlt: string;
    bodySupport: string;
    bodySupportLight: string;
    bodyMid: string;
    bodyLight: string;
    bodyLightest: string;
    bodyMute: string;

    borderBlue: string;
    borderLightShadow: string;
    borderBlueHaze: string;

    generalWarning: string;
    generalWarningLight: string;
    generalLink: string;
    generalPositive: string;
    generalPositiveLight: string;
    generalRating: string;
    generalSale: string;
    generalFreebie: string;
    gereralIconBG: string;
    generalDeal: string;
    generalAttachment: string;
    generalLabel: string;
    generalBadge: string;
    generalBlack: string;
    generalManatee: string;
    marketBlue: string;

    statusOrdered: string;
    statusProcessing: string;
    statusShipped: string;
    bgOverlay: string;
};

// --- Colors
export const colors: TNoonColors = {
    // Brand
    brandPrimary: '#feee00', // Yellow
    brandSecondary: '#3866df', // Blue
    brandTertiary: '#3866df', // Blue (change) #TODO

    // Background
    bgPrimary: '#fff', // White
    bgSecondary: '#404553', // Dark Grey
    bgSupport: '#fcfbf4', // Pale Yellow
    bgTertiary: '#f7f7fa', // Light-Grey
    bgSupportAlt: '#F7F9FE', // Light Grey-Blue
    bgSupportLight: '#F1F4FD', // Light Transparent Blue
    bgTrigger: '#FFF8EC',

    // Body
    body: '#404553', // Dark-Grey
    bodyDark: '',
    bodyAlt: '#fff',
    bodySupport: '#877700', // dark yellow
    bodySupportLight: '#FEEE00', // bright yellow
    bodyMid: '#7E859B', // Mid dark Grey
    bodyLight: '#e2e5f1', // Dark-Grey
    bodyLightest: '#f7f7fa', // Light-Grey
    bodyMute: '#b2bbd2',

    // Border
    border: '#f1f3f9',
    borderLight: '#ebecf0',
    borderDark: '#e2e5f1',
    borderBlue: '#008FBE',
    borderLightShadow: '#f1f1f1',
    borderBlueHaze: '#c6ccdd',

    // Font
    fontColor: '',
    fontColorDark: '',
    fontColorLight: '#b2b8ca',
    fontColorContrast: '#a3abc0',

    // General
    generalWarning: '#ce0f0f', // Red
    generalWarningLight: '#fb0000', // Light-Red
    generalLink: '#3866df', // Blue
    generalPositive: '#38ae04', // Green
    generalPositiveLight: '#e4f7db', // Light-Green
    generalRating: '#f5a523', // Orange
    generalSale: '#f6583d', // Coral
    generalFreebie: '#00B06A', // Green
    gereralIconBG: '#fcfbf4', // Light Yellow
    generalDeal: '#6236FF', // Purple
    generalAttachment: '#FAF9ED',
    generalLabel: '',
    generalBadge: '',
    generalBlack: '',
    generalManatee: '#8d94a7',
    marketBlue: '#324B93',

    // Status
    statusOrdered: '#AEAEAB',
    statusProcessing: '#C9B8A0',
    statusShipped: '#E0C35C',
    bgOverlay: '#363940',
};

export const metrics = {
    headerHeight: 60,
    bottomTabsHeight: 60,
};

const spacing = {
    xs: '10px',
    sm: '12px',
    md: '15px',
};

const shadow = css`
    box-shadow: 0px 1px 5px 2px rgba(173, 193, 207, 0.35);
`;

const fontRoot = `${process.env.CDN}/s/app/com/common/fonts`;

export const basefontSize = '14px';

export const marketplaceStyles = (): string => {
    return `
      /* Proxima Nova (English) */
      @font-face {
        font-family: "Proxima Nova";
        src: url("${fontRoot}/Proxima-Nova-300.eot?#iefix");
        src: url("${fontRoot}/Proxima-Nova-300.eot?#iefix") format("eot"),
          url("${fontRoot}/Proxima-Nova-300.woff2") format("woff2"),
          url("${fontRoot}/Proxima-Nova-300.woff") format("woff"),
          url("${fontRoot}/Proxima-Nova-300.ttf") format("truetype");
        font-weight: 300;
        font-style: normal;
      }
      @font-face {
        font-family: "Proxima Nova";
        src: url("${fontRoot}/proxima-v2/Proxima-Nova-Regular.eot?#iefix");
        src: url("${fontRoot}/proxima-v2/Proxima-Nova-Regular.eot?#iefix") format("eot"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Regular.woff2") format("woff2"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Regular.woff") format("woff"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Regular.ttf") format("truetype");
        font-weight: normal;
        font-style: normal;
      }
      @font-face {
        font-family: "Proxima Nova";
        src: url("${fontRoot}/proxima-v2/Proxima-Nova-Semibold.eot?#iefix");
        src: url("${fontRoot}/proxima-v2/Proxima-Nova-Semibold.eot?#iefix") format("eot"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Semibold.woff2") format("woff2"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Semibold.woff") format("woff"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Semibold.ttf") format("truetype");
        font-weight: 600;
        font-style: normal;
      }
      @font-face {
        font-family: "Proxima Nova";
        src: url("${fontRoot}/proxima-v2/Proxima-Nova-Bold.eot?#iefix");
        src: url("${fontRoot}/proxima-v2/Proxima-Nova-Bold.eot?#iefix") format("eot"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Bold.woff2") format("woff2"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Bold.woff") format("woff"),
          url("${fontRoot}/proxima-v2/Proxima-Nova-Bold.ttf") format("truetype");
        font-weight: bold;
        font-style: normal;
      }
      /* Cairo (Arabic) */
      @font-face {
        font-family: 'Cairo';
        font-style: normal;
        font-weight: 400;
        src: local('Cairo'), local('Cairo-Regular'), url(https://fonts.gstatic.com/s/cairo/v2/KHiPzIiPko_Fw3pWntR2CoDGDUGfDkXyfkzVDelzfFk.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+E0FF, U+EFFD, U+F000, U+FB50-FDFF, U+FE80-FEFC;
      }
      /* latin */
      @font-face {
        font-family: 'Cairo';
        font-style: normal;
        font-weight: 400;
        src: local('Cairo'), local('Cairo-Regular'), url(https://fonts.gstatic.com/s/cairo/v2/9AWxzDXz2R7tHfJeCoIOqqCWcynf_cDxXwCLxiixG1c.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2212, U+2215;
      }
      /* arabic */
      @font-face {
        font-family: 'Cairo';
        font-style: normal;
        font-weight: 600;
        src: local('Cairo SemiBold'), local('Cairo-SemiBold'), url(https://fonts.gstatic.com/s/cairo/v2/MI6TrIXLGD9aHguHYHeGURkAz4rYn47Zy2rvigWQf6w.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+E0FF, U+EFFD, U+F000, U+FB50-FDFF, U+FE80-FEFC;
      }
      /* latin */
      @font-face {
        font-family: 'Cairo';
        font-style: normal;
        font-weight: 600;
        src: local('Cairo SemiBold'), local('Cairo-SemiBold'), url(https://fonts.gstatic.com/s/cairo/v2/nDAflKnJsVnfdGOoytL7mHYhjbSpvc47ee6xR_80Hnw.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2212, U+2215;
      }
      /* arabic */
      @font-face {
        font-family: 'Cairo';
        font-style: normal;
        font-weight: 700;
        src: local('Cairo Bold'), local('Cairo-Bold'), url(https://fonts.gstatic.com/s/cairo/v2/RLgQnjqLWN5-LcxkRZr1cBkAz4rYn47Zy2rvigWQf6w.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+E0FF, U+EFFD, U+F000, U+FB50-FDFF, U+FE80-FEFC;
      }
      /* latin */
      @font-face {
        font-family: 'Cairo';
        font-style: normal;
        font-weight: 700;
        src: local('Cairo Bold'), local('Cairo-Bold'), url(https://fonts.gstatic.com/s/cairo/v2/IGeshMgNVhb2XU2TGWkITnYhjbSpvc47ee6xR_80Hnw.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2212, U+2215;
      }

      :root {
        --swiper-theme-color: grey !important;
      }

      html,
      body {
        line-height: 1.3;
        color: #404553;
        font-size: ${basefontSize};
        background-color: #f7f7fa;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      input, textarea, select  {
        border: 1px solid #e2e5f1;
        font-size: 16px;
      }

      body {
        font-family: 'Proxima Nova', 'Helvetica Neue', Arial, sans-serif !important;
        min-height: 100vh;
      }

      html[dir=rtl] body {
        font-family: Cairo, sans-serif !important;
      }

      .siteWidthContainer {
        padding: 0 15px;
        margin: 0 auto;
        max-width: 768px;
        box-sizing: border-box;
      }
      @media ${breakpoints.minTablet} {
          .siteWidthContainer {
              padding: 0 25px;
              min-width: 768px;
              max-width: 1440px;
          }
      }

      @media ${breakpoints.minDesktop} {
          .siteWidthContainer {
              padding: 0 45px;
          }
      }

      strong, b {
        font-weight: bold;
      }

      a {
          text-decoration: none;
          cursor: pointer;
          color: inherit;
      }

      /* remember to define focus styles! */
      a:focus,
      button:focus,
      input:focus {
          outline: 0;
      }`;
};

export const transitions = {
    fade: {
        base: {
            transition: `opacity 250ms ease-in-out, visibility 100ms ease-in-out 250ms`,
            zIndex: 1,
            opacity: 0,
            visibility: 'visible',
        },
        state: {
            entering: { opacity: 0.5 },
            entered: { opacity: 1 },
            exiting: { opacity: 0.5 },
            exited: { opacity: 0, visibility: 'hidden' },
        },
    },
};

export const misc = {
    siteHeaderHeightMobile: '50px',
    storeHeaderHeightDesktop: '50px',
    siteHeaderHeightDesktop: '65px',
};

const theme = {
    colors,
    metrics,
    spacing,
    shadow,
    transitions,
    misc,
};

export default theme;
